var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9967 1.08749C15.9067 1.53106 15.6402 1.89774 15.3604 2.26147C13.4183 4.77503 11.4795 7.2886 9.54408 9.80216C9.29757 10.1215 9.01442 10.3965 8.60801 10.5533C7.99173 10.7898 7.29218 10.6509 6.79582 10.1866C6.66924 10.0713 6.55598 9.94115 6.45604 9.80808C4.46063 7.22354 2.46523 4.63605 0.473159 2.04855C0.256629 1.76763 0.0667495 1.47783 0.0134496 1.13184C-0.0698319 0.581816 0.236641 0.179645 0.849586 0.0613599C1.06279 0.01996 1.28265 0.00221721 1.49918 0.00221722C5.82977 -0.000739728 10.1604 -0.000739539 14.491 0.00221779C14.7275 0.0022178 14.9707 0.0258749 15.2005 0.0761462C15.6269 0.170775 15.9001 0.422131 16 0.809516C15.9967 0.901187 15.9967 0.992858 15.9967 1.08749Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.88ec762087a140ab31b5400a1b41164f.svg";
export { ForwardRef as ReactComponent };